// extracted by mini-css-extract-plugin
export var container = "Breadcrumb-module--container--e387e";
export var link = "Breadcrumb-module--link--23ca1";
export var spacer = "Breadcrumb-module--spacer--df8a8";